import { render, staticRenderFns } from "./createOrEdit.vue?vue&type=template&id=0a078214&scoped=true&"
import script from "./createOrEdit.vue?vue&type=script&lang=js&"
export * from "./createOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a078214",
  null
  
)

export default component.exports